import styled, { css } from 'styled-components'
import { Link as RRLink } from 'react-router-dom'
import { colors } from 'theme'

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  min-width: 300px;
`

export const Container = styled.div`
  max-width: 1100px;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 4vw;
`

const linkBase = css`
  color: inherit;
  cursor: pointer;
  text-decoration: none;
  font-weight: 800;
  font-size: 14px;
  color: ${colors.success};
`

export const LinkAnchor = styled.a`
  ${linkBase}
`

export const Link = styled(RRLink)`
  ${linkBase}
`

export const Anchor = styled.a`
  color: inherit;
  cursor: pointer;
  text-decoration: none;
`
